import { postRequest } from "./request";

export function VesselListOnload(dataObject) {
  const userData = JSON.parse(localStorage.getItem("userData"));
  return postRequest({
    path: `get-vessel-details`,
    token: userData.token,
  }).then((response) => {
    return response ? response : undefined;
  });
}
